import React from "react"
import PropTypes from "prop-types"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { Modal } from "antd"

const AssetNumbersModal = ({ open, onClose, equipmentName, assetNumbers }) => {
  const { t } = useTranslation()

  return (
    <Modal
      centered
      open={open}
      footer={null}
      onCancel={onClose}
      title={
        <Text fw={600} size="lg">
          Equipment - {equipmentName}
        </Text>
      }
    >
      <div className={styles.description}>
        <Text fw={500}>{t("booking.equipment.asset_numbers_description")}</Text>

      </div>
      {assetNumbers?.map((assetNumber) => (
        <div key={assetNumber} className={styles.assetRow}>
          <Text>{assetNumber}</Text>
        </div>
      ))}
    </Modal>
  )
}

AssetNumbersModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  equipmentName: PropTypes.string.isRequired,
  assetNumbers: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default AssetNumbersModal
